
export enum EPendingChangesSelectedAction {
    DONOTHING,
    CANCEL,
    SAVE,
    DONTSAVE,
    CONTINUE
}

export enum EHasChangesStatus {
    PENDING,
    HASCHANGES,
    DONTHASCHANGES
}